import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  add as addUserRole
} from '../redux/userRoles'

export default function * requestAddUserRole (action) {
  const { userId, role } = action.payload

  const optimisticAction = yield optimisticPut(addUserRole({
    userId,
    role,
  }))

  try {
    yield call(apiAction, 'AddUserRole', {
      userId,
      role,
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  } finally {
    yield optimisticAction.revert()
  }
}
